import { BookOutline, Course } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import type { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Course];

const config: ContentConfigProps = {
  routes: {
    create: routes.CourseCreator,
    edit: routes.CourseBuilder,
    view: routes.CourseViewer,
    details: routes.CourseDetails,
    manageDetails: routes.AdminCourseDetails,
  },
  label: { title, createDescription },
  icons: {
    Type: Course,
    Create: BookOutline,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
